<template>
  <div>
    <SlideModal
      ref="MBottomMenuWallet"
      name="MBottomMenuWallet"
      slide-direction="left"
      data-bs-toggle="modal"
      data-bs-target="#MBottomMenuWallet"
      custom-class="m-bottom-menu-wallet"
    >
      <div class="m-bottom-menu-wallet-content">
        <button
          v-for="mainBottomMenuWalletListItem in comMainBottomMenuWalletList"
          :key="mainBottomMenuWalletListItem.type"
          class="m-bottom-menu-wallet-link"
          :class="mainBottomMenuWalletListItem.type"
          @click.prevent="$router.push(`${mainBottomMenuWalletListItem.link}`)"
        >
          <i :class="`mc-${mainBottomMenuWalletListItem.icon}`"></i>
          <span>{{
            $t(
              `layout.Footer.mobile.bottomMenu.list.${
                mainBottomMenuWalletListItem.type
              }`
            )
          }}</span>
        </button>
      </div>
    </SlideModal>
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api'
import useComp from '../../../composables/useComp'
import SlideModal from '../../components/SlideModal.vue'
import useUser from '../../../composables/useUser'

export default defineComponent({
  name: 'MBottomMenuGame',
  components: { SlideModal },
  props: {},
  setup(props, context) {
    const { user } = useUser(context)
    const { compCommon, comMainBottomMenuWalletList, compId } = useComp()
    const templateId = computed(() => process.env.TEMPLATE_ID)

    return {
      compCommon,
      compId,
      templateId,
      comMainBottomMenuWalletList,
      user
    }
  }
})
</script>
